// extracted by mini-css-extract-plugin
module.exports = {"projectTeam":"header-module--projectTeam--EomQN","active":"header-module--active--3VKnK"};